// Flèches précédent/suivant + compteur "1 / N" pour l'image principale de
// la galerie produit, sur ordinateur uniquement (≥990px). Absents de Dawn
// en mode thumbnail/thumbnail_slider desktop (seule l'image active a une
// largeur, donc le slider-component natif — basé sur scrollLeft — ne peut
// pas fonctionner ici). Plutôt que de dupliquer la logique de changement de
// média, ce script réutilise le mécanisme déjà fiable et testé de Dawn :
// un clic sur une flèche simule un clic sur la miniature précédente/suivante
// (media-gallery.js gère alors is-active, l'accessibilité et le défilement
// des miniatures, exactement comme un vrai clic utilisateur).
//
// Correctif (septembre 2026) : l'état désactivé des flèches et le compteur
// visible dépendaient auparavant de l'évènement natif "slideChanged", que
// SliderComponent ne déclenche que lorsque son scrollLeft change — or en
// mode thumbnail_slider desktop, seule l'image active a une largeur non
// nulle, donc ce slider ne scrolle jamais et cet évènement ne se déclenche
// jamais. Résultat : les flèches restaient activées aux extrémités et le
// compteur restait bloqué sur "1". On calcule et met désormais nous-mêmes
// l'état à jour ("refresh") directement au clic sur n'importe quelle
// miniature (déclenché par l'utilisateur OU simulé par goTo), sans dépendre
// de cet évènement natif défaillant dans ce mode.
(function () {
  if (window.__pdpDesktopArrowsInit) return;
  window.__pdpDesktopArrowsInit = true;

  var desktopQuery = window.matchMedia('(min-width: 990px)');

  function setup(viewer) {
    if (viewer.dataset.desktopArrowsReady) return;

    var wrap = viewer.closest('media-gallery');
    if (!wrap) return;
    var thumbnails = wrap.querySelector('[id^="GalleryThumbnails-"]');
    if (!thumbnails) return;

    var slides = Array.from(viewer.querySelectorAll('[id^="Slide-"]'));
    var arrowWrap = viewer.querySelector('.slider-buttons');
    if (!arrowWrap || slides.length === 0) return;

    viewer.dataset.desktopArrowsReady = 'true';

    if (slides.length <= 1) {
      arrowWrap.style.display = 'none';
      return;
    }

    var prevBtn = arrowWrap.querySelector('button[name="previous"]');
    var nextBtn = arrowWrap.querySelector('button[name="next"]');
    if (!prevBtn || !nextBtn) return;

    var counterCurrent = arrowWrap.querySelector('.slider-counter--current');
    var counterTotal = arrowWrap.querySelector('.slider-counter--total');

    function currentIndex() {
      var index = slides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      });
      return index === -1 ? 0 : index;
    }

    function goTo(index) {
      if (index < 0 || index >= slides.length) return;
      var mediaId = slides[index].dataset.mediaId;
      var thumbButton = thumbnails.querySelector('[data-target="' + mediaId + '"] button');
      if (thumbButton) thumbButton.click();
    }

    function refresh() {
      var index = currentIndex();
      prevBtn.disabled = index <= 0;
      nextBtn.disabled = index >= slides.length - 1;
      if (counterCurrent) counterCurrent.textContent = index + 1;
      if (counterTotal) counterTotal.textContent = slides.length;
    }

    prevBtn.addEventListener('click', function () {
      goTo(currentIndex() - 1);
    });
    nextBtn.addEventListener('click', function () {
      goTo(currentIndex() + 1);
    });

    // Se déclenche pour un clic sur une miniature, qu'il vienne de
    // l'utilisateur ou de goTo() ci-dessus (thumbButton.click() déclenche
    // les mêmes écouteurs qu'un vrai clic).
    thumbnails.querySelectorAll('[data-target] button').forEach(function (thumbButton) {
      thumbButton.addEventListener('click', refresh);
    });

    // Conservé en filet de sécurité au cas où l'évènement natif se
    // déclencherait malgré tout (autre mode de galerie, évolution future).
    viewer.addEventListener('slideChanged', refresh);

    refresh();
  }

  function init() {
    if (!desktopQuery.matches) return;
    document.querySelectorAll('media-gallery [id^="GalleryViewer-"]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  desktopQuery.addEventListener('change', init);
})();
